enum ContentExtractionDialogFields {
	MODE = 'mode',
	FILE_FORMAT = 'fileFormat',
	REMOVE_PUNCTUATION = 'removePunctuation',
	DELIMIT_AFTER_PUNCTUATION = 'delimitAfterPunctuation',
	EXTENDED_SEQUENCE_CHARACTERS = 'extendedSequenceCharacters',
	FROM_TEXT = 'fromText',
	FALLBACK_FORMAT = 'fallbackFormat',
	PAGERANGE = 'pagerange'
}

export default ContentExtractionDialogFields;